import React from "react";

import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import API from "@beardeddevops/react.api";
import CollectionOverride from "components/CollectionOverride";



export default class Blacklist extends CollectionOverride {
	constructor(props) {
		let model = new API.BuildClass(Types.Customers._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 3;
		this.limit = 3;
		this.request = 'GET_BLACKLIST';
	}

	handleDeleteBlacklist = (pkey, binary_id) => async () => {
		this.model.object.pkey = pkey;
		this.model.object.binary_id = binary_id;
		try {
			await this.model.submit(null, "DELETE_BLACKLIST");
			this.reloadTable();
		} catch (error) {
		}
	};

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [

			{
				Header: "Blacklist Name",
				accessor: "pkey",
				Cell: props => <Link
					to={"/customers/" + props.original.binary_id + '-' + props.value}>{props.original.name_first} {props.original.name_last}</Link>
			},
			{
				Header: "Address",
				id: "customer_addresses.street_1",
				/** @param {Customers_Object} obj */
				accessor: obj => (obj.customer_addressess && obj.customer_addressess.length > 0 && obj.customer_addressess[0].street_1) ? obj.customer_addressess[0].street_1 + ' ' + obj.customer_addressess[0].city + ', ' + obj.customer_addressess[0].state + ' ' + obj.customer_addressess[0].zip : '-'
			},
			{
				Header: "DOB",
				id: "birth_date",
				width: 100,
				/** @param {Customers_Object} obj */
				accessor: obj => {
					return obj.birth_date ? moment(obj.birth_date).local().format("MM/DD/YYYY") : '-'
				}
			},
			{
				Header: "Date Blacklisted",
				id: "blacklist_date",
				width: 100,
				/** @param {Customers_Object} obj */
				accessor: obj => {
					return obj.blacklist_date ? moment(obj.blacklist_date).local().format("MM/DD/YYYY") : '-'
				}
			},
			{
				Header: "Reason",
				id: "blacklist_reason",
				/** @param {Customers_Object} obj */
				accessor: obj => (obj.blacklist_reason ? obj.blacklist_reason : '')
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						<span>
							<Link to={`/customers/${props.original._id}`}>
								<Button color="green-meadow" size={"sm"} block={true}>
									<i className={"fa fa-pencil"}/></Button>
							</Link>
						</span>
					);
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						<span>
							<Button color="danger" size={"sm"} block={true}
							        onClick={this.handleDeleteBlacklist(props.original.pkey, props.original.binary_id)}>
								<i className={"fa fa-times"}/></Button>
						</span>
					);
				}
			},

		];

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Blacklisted Customers', "")}
							{this.renderHeaderRight("Blacklisted Customers", columns)}

						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSize={limit}
						pageSizeOptions={[3, 5, 10, 20, 25, 50, 100, 500, 1000]}
						className="-striped -highlight"
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
